<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance" id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_modals_resubscribe_successfully_unsubscribe_msg') }}</h1>
          <img class="modal_icon_main" src="/static/images/unsubscribe.png" alt="">
          <p>{{ getTranslations.home_modals_resubscribe_reactivate_account_msg_new }} </p>

          <a class="ti_btn--main" @click.prevent="reOptin" style="cursor:pointer">
              {{ getTranslations.home_modals_resubscribe_resubscribe_new }}

          </a>
          <span class="terms">
          {{ getTranslations.home_modals_resubscribe_by_clicking }}
          <br>
            <span class="make_it_bold">
           <a style="cursor:pointer" :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.home_modals_resubscribe_request_t_and_cs
             }}</a> </span> {{ getTranslations.home_modals_resubscribe_request_of_the_service }}
        </span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import modals from '../../../common/modals';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeViaPin from './ResubscribeViaPin';
import ResubscribeError from './store/ConfirmPurchaseForPinError';

export default {
  // It is correct (the name is from previous versions): modal_unsubscribe_confirmation.html
  name: 'resubscribe',
  mixins: [IntegrationMixin],
  components: {
    WelcomeReturningUnsub,
    ResubscribeViaPin,
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
    ]),
    ...mapActions('common', [
      'reOptinProcess',
    ]),
    goToTermsPage() {
      this.$router.push('/home/terms');
    },
    reSubCallback(response) {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        this.getUserLoginDetails().then(() => {
          if (this.reoptinOnestep) {
            if (this.userDetails.subscribed) {
              this.storeModalForSettings(WelcomeReturningUnsub);
              modals.showHideModalForHomePage(this);
            } else {
              this.storeModalForSettings(ResubscribeError);
              modals.showHideModalForHomePage(this);
            }
          } else {
            // eslint-disable-next-line
            if (this.userDetails.subscribed) {
              this.storeModalForSettings(ResubscribeError);
              modals.showHideModalForHomePage(this);
            } else {
              this.storeModalForSettings(ResubscribeViaPin);
              modals.showHideModalForHomePage(this);
            }
          }
        });
      } else {
        this.storeModalForSettings(ResubscribeError);
        modals.showHideModalForHomePage(this);
      }
    },
    reOptin() {
      // eslint-disable-next-line
      console.log('Resubscribe user Call');
      this.getAppropriateReSubAction();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
      'reoptinOnestep',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/Resubscribe.vue